export default "__VITE_ASSET__2bwszSXA__"